(function () {
  'use strict';

  function preOrderLabel() {
    return (window.inventory_text && window.inventory_text.pre_order) || 'Pre Order';
  }

  function addToCartLabel() {
    return (window.inventory_text && window.inventory_text.add_to_cart) || 'Add to cart';
  }

  window.isPreOrderVariant = function (productId, variantId) {
    var map = window.preOrderVariantData && window.preOrderVariantData[productId];
    if (!map) return false;
    var v = map[String(variantId)];
    if (!v || !v.available) return false;
    return v.qty <= 0 && v.policy === 'continue';
  };

  function getProductIdFromVariant(variantId) {
    var data = window.preOrderVariantData || {};
    var key = String(variantId);
    for (var productId in data) {
      if (Object.prototype.hasOwnProperty.call(data, productId) && data[productId][key]) {
        return productId;
      }
    }
    return null;
  }

  function getProductIdFromForm(form) {
    var root = form && form.closest('[data-product-id]');
    if (root) return root.getAttribute('data-product-id');
    var variantId = form && (form.querySelector('[name="id"]') || {}).value;
    return variantId ? getProductIdFromVariant(variantId) : null;
  }

  function getProductTitle(productId) {
    return (window.preOrderProductTitle && window.preOrderProductTitle[productId]) || 'this product';
  }

  function customerHasPreOrderProduct(productId) {
    var list = window.preOrderPurchasedProducts || [];
    return list.some(function (id) {
      return String(id) === String(productId);
    });
  }

  function cartHasPreOrderProduct(productId) {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return cart.items.some(function (item) {
          return String(item.product_id) === String(productId);
        });
      })
      .catch(function () { return false; });
  }

  window.getProductIdFromVariant = getProductIdFromVariant;
  window.checkPreOrderAllowed = function (productId) {
    if (!productId) return Promise.resolve({ allowed: true });

    if (customerHasPreOrderProduct(productId)) {
      return Promise.resolve({ allowed: false, reason: 'purchased' });
    }

    return cartHasPreOrderProduct(productId).then(function (inCart) {
      if (inCart) return { allowed: false, reason: 'cart' };
      return { allowed: true };
    });
  };

  function formIsPreOrder(form) {
    var btn = form.querySelector('[data-pre-order="true"], [data-pre-order-btn]');
    if (btn) return true;
    btn = form.querySelector('#product-add-to-cart, .product-add-to-cart, .sb-add-to-cart, #gfqv-btn, .sticky-add-to-cart');
    if (!btn) return false;
    var val = (btn.value || btn.textContent || '').trim();
    return val === preOrderLabel() || val.toUpperCase() === 'PRE ORDER';
  }

  function hideCheckboxError(form) {
    var scope = form || document;
    var nodes = form
      ? scope.querySelectorAll('[data-pre-order-checkbox-msg]')
      : document.querySelectorAll('[data-pre-order-checkbox-msg]');
    nodes.forEach(function (el) {
      el.classList.remove('is-visible', 'bounceIn');
      el.style.display = 'none';
    });
  }

  function showCheckboxError(form) {
    hideLimitMessage();
    var msg = form.querySelector('[data-pre-order-checkbox-msg]');
    if (!msg) {
      msg = document.querySelector('[data-pre-order-checkbox-msg]');
    }
    if (msg) {
      msg.style.display = 'block';
      msg.classList.add('is-visible', 'bounceIn');
    }
    var checkbox = form.querySelector('.pre-order-checkbox-input, #pre-order, [name="properties[Pre order]"]');
    if (!checkbox) {
      checkbox = document.querySelector('.pre-order-checkbox-input[form="' + form.id + '"]');
    }
    if (checkbox) {
      checkbox.style.outline = '2px solid #c0392b';
      checkbox.focus();
    }
  }

  window.showPreOrderCheckboxError = showCheckboxError;
  window.hidePreOrderCheckboxError = hideCheckboxError;

  function validatePreOrderCheckbox(form) {
    var checkbox = form.querySelector('.pre-order-checkbox-input, #pre-order, [name="properties[Pre order]"]');
    if (!checkbox && form.id) {
      checkbox = document.querySelector('.pre-order-checkbox-input[form="' + form.id + '"]');
    }
    if (!checkbox) return true;
    if (checkbox.checked) {
      checkbox.style.outline = '';
      hideCheckboxError(form);
      return true;
    }
    showCheckboxError(form);
    return false;
  }

  function hideLimitMessage() {
    document.body.classList.remove('matched');
    document.querySelectorAll('[data-pre-order-limit-msg], .limit-reached-message').forEach(function (el) {
      el.classList.remove('bounceIn', 'is-visible');
      el.style.display = 'none';
    });
  }

  function limitMessageText(productId, reason) {
    var title = getProductTitle(productId);
    if (reason === 'cart') {
      return 'This pre-order is already in your cart. You can only pre-order ' + title + ' once.';
    }
    return 'You have already pre-ordered ' + title + '. Each customer can only pre-order this product once.';
  }

  function showLimitMessage(form, reason) {
    hideLimitMessage();
    hideCheckboxError(form);
    document.body.classList.add('matched');
    var productId = getProductIdFromForm(form);
    var text = limitMessageText(productId, reason);
    var msg = form.querySelector('[data-pre-order-limit-msg], .limit-reached-message');
    if (!msg) {
      msg = document.querySelector('[data-pre-order-limit-msg], .limit-reached-message');
    }
    if (msg) {
      msg.textContent = text;
      msg.style.display = 'block';
      msg.classList.add('is-visible', 'bounceIn');
    }
  }

  function preOrderForms() {
    return '#add-to-cart-form, #add-to-cart-form-desktop, #add-to-cart-form-mobile, #add-to-cart-quickview-form, #add-to-cart-gf-quickview-form, #form-sticky, [data-pre-order-form]';
  }

  function proceedPreOrderAdd(form) {
    var fd = new FormData(form);
    var params = new URLSearchParams(fd).toString();
    if (window.ella && typeof window.ella.doAjaxAddToCartNormal === 'function') {
      var titleEl = document.querySelector('.product-title, .sb-title');
      var imgEl = document.querySelector('.product-photo-container img, .sb-slide-image');
      window.ella.doAjaxAddToCartNormal(params, titleEl ? titleEl.textContent : '', imgEl ? imgEl.src : '');
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params
      }).then(function () {
        window.location.href = '/cart';
      });
    }
  }

  function validatePreOrderPurchase(form) {
    var productId = getProductIdFromForm(form);
    return window.checkPreOrderAllowed(productId).then(function (result) {
      if (!result.allowed) {
        showLimitMessage(form, result.reason);
        return false;
      }
      return true;
    });
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || form.tagName !== 'FORM' || !form.matches(preOrderForms())) return;
    if (!formIsPreOrder(form)) return;

    ev.preventDefault();
    if (!validatePreOrderCheckbox(form)) return;

    validatePreOrderPurchase(form).then(function (allowed) {
      if (allowed) form.submit();
    });
  }, true);

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-btn-addToCart], [data-grouped-addToCart], [data-sticky-btn-addToCart], .sb-add-to-cart[data-pre-order="true"]');
    if (!btn) return;

    var formSelector = btn.getAttribute('data-form-id');
    var form = formSelector ? document.querySelector(formSelector) : btn.closest('form');
    if (!form || !formIsPreOrder(form)) return;

    ev.preventDefault();
    ev.stopImmediatePropagation();

    if (!validatePreOrderCheckbox(form)) return;

    validatePreOrderPurchase(form).then(function (allowed) {
      if (allowed) proceedPreOrderAdd(form);
    });
  }, true);

  window.updatePreOrderButton = function (btn, productId, variantId) {
    if (!btn) return;
    var isPre = window.isPreOrderVariant(productId, variantId);
    if (isPre) {
      btn.setAttribute('data-pre-order', 'true');
      if (btn.tagName === 'INPUT') btn.value = preOrderLabel();
      else btn.textContent = preOrderLabel().toUpperCase();
      btn.disabled = false;
      btn.classList.remove('disabled');
    } else {
      btn.setAttribute('data-pre-order', 'false');
      if (btn.tagName === 'INPUT') btn.value = addToCartLabel();
      else btn.textContent = (btn.classList.contains('sb-add-to-cart') ? 'ADD TO CART' : addToCartLabel());
    }
  };

  window.updatePreOrderUI = function (productId, variantId) {
    var isPre = window.isPreOrderVariant(productId, variantId);
    document.querySelectorAll('.product, .sb-product-template, .quickview-tpl').forEach(function (root) {
      root.classList.toggle('is-pre-order', isPre);
      if (root.hasAttribute('data-var')) {
        root.setAttribute('data-var', isPre ? 'Pre-Order' : 'In Stock');
      }
    });
    document.querySelectorAll('[data-pre-order-controls], .pre-order-shipping-message').forEach(function (el) {
      el.style.display = isPre ? '' : 'none';
    });
    document.querySelectorAll('[data-pre-order-limit-msg], .limit-reached-message').forEach(function (el) {
      el.classList.remove('bounceIn', 'is-visible');
      el.style.display = 'none';
    });
    hideCheckboxError();
    if (document.body.classList.contains('matched')) {
      document.body.classList.remove('matched');
    }
    document.querySelectorAll('.pre-order-badge, .pre-order-title').forEach(function (el) {
      el.style.display = isPre ? '' : 'none';
    });
    document.querySelectorAll('.qty-group').forEach(function (el) {
      var input = el.querySelector('input[name="quantity"]');
      if (isPre) {
        el.classList.add('pre-Order');
        if (input) {
          input.value = '1';
          input.setAttribute('readonly', 'readonly');
        }
      } else {
        el.classList.remove('pre-Order');
        if (input) input.removeAttribute('readonly');
      }
    });
    document.querySelectorAll('.sb-add-to-cart, #product-add-to-cart, .product-add-to-cart, .sticky-add-to-cart, #gfqv-btn').forEach(function (btn) {
      window.updatePreOrderButton(btn, productId, variantId);
    });

    if (isPre) {
      window.checkPreOrderAllowed(productId).then(function (result) {
        if (!result.allowed) {
          var form = document.querySelector(preOrderForms());
          if (form) showLimitMessage(form, result.reason);
        }
      });
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    hideLimitMessage();
    installCheckoutRedirectGuard();
    initLoginPageCheckoutUrlFix();
    initOtpInterceptors();
    initPreOrderCartFlag();
    initPostLoginCartCheck();
    initGlobalCheckoutGuard();
    initProductPageGuard();
    initCartPageGuard();
  });

  function isPreOrderLineItem(item) {
    if (!item || !item.properties) return false;
    var props = item.properties;
    return !!(props['Pre order'] || props['pre-Order']);
  }

  function cartJsonHasPreOrderItems() {
    var cart = window.simplyOtp && window.simplyOtp.cartJson;
    if (!cart || !cart.items) return false;
    return cart.items.some(isPreOrderLineItem);
  }

  function domHasPreOrderCartLines() {
    return !!document.querySelector('[data-pre-order-cart-line="true"]');
  }

  function syncCartHasPreOrderItems() {
    return domHasPreOrderCartLines() || cartJsonHasPreOrderItems();
  }

  function shouldForceCartReturn() {
    return sessionStorage.getItem('preOrderForceCartReturn') === '1'
      || sessionStorage.getItem('preOrderCartHasPreOrder') === '1'
      || syncCartHasPreOrderItems();
  }

  function hasCheckoutLoginIntent() {
    if (window.hasActiveCheckoutLoginIntent) {
      return window.hasActiveCheckoutLoginIntent();
    }
    var params = new URLSearchParams(window.location.search);
    if (params.has('checkout_url')) return true;
    var returnUrl = params.get('return_url');
    return !!(returnUrl && /\/checkout/i.test(returnUrl));
  }

  function shouldOverrideCheckoutLogin() {
    if (!hasCheckoutLoginIntent()) return true;
    return syncCartHasPreOrderItems();
  }

  function cartReturnUrl() {
    return window.location.origin + '/cart?post_login=1';
  }

  function rewriteOtpReturnToCart() {
    var cartPath = '/cart?post_login=1';
    document.querySelectorAll('[name="return_url"], #otp-return_to').forEach(function (el) {
      el.value = cartPath;
    });
    document.querySelectorAll('[name="checkout_url"]').forEach(function (el) {
      el.remove();
    });
    if (window.simplyOtp && window.simplyOtp.settings) {
      window.simplyOtp.settings.pageUrl = cartPath;
    }
  }

  window.rewriteOtpReturnToCart = rewriteOtpReturnToCart;

  var otpReturnWatcher = null;

  function startOtpReturnUrlWatcher() {
    if (otpReturnWatcher) return;
    var ticks = 0;
    otpReturnWatcher = setInterval(function () {
      ticks += 1;
      if (ticks > 150 || !shouldForceCartReturn()) {
        clearInterval(otpReturnWatcher);
        otpReturnWatcher = null;
        return;
      }
      rewriteOtpReturnToCart();
    }, 50);
  }

  function markPreOrderCheckoutIntent() {
    sessionStorage.setItem('preOrderForceCartReturn', '1');
    sessionStorage.setItem('preOrderCartHasPreOrder', '1');
    window.preOrderBlockCheckoutRedirect(120000);
    rewriteOtpReturnToCart();
    startOtpReturnUrlWatcher();
  }

  var checkoutRedirectBlockedUntil = 0;

  window.preOrderBlockCheckoutRedirect = function (durationMs) {
    checkoutRedirectBlockedUntil = Date.now() + (durationMs || 120000);
  };

  window.allowCheckoutAfterLogin = function () {
    checkoutRedirectBlockedUntil = 0;
    window.__preOrderAllowCheckout = true;
  };

  function isCheckoutNavigation(url) {
    return /\/checkout/i.test(String(url || ''));
  }

  function shouldBlockCheckoutRedirect(url) {
    if (window.__preOrderAllowCheckout) return false;
    if (Date.now() > checkoutRedirectBlockedUntil) return false;
    return isCheckoutNavigation(url);
  }

  function redirectToCartAfterLogin() {
    sessionStorage.removeItem('preOrderForceCartReturn');
    sessionStorage.setItem('preOrderPostLoginCheck', '1');
    window.preOrderBlockCheckoutRedirect(120000);
    window.location.replace('/cart?post_login=1');
  }

  function installCheckoutRedirectGuard() {
    if (window.__preOrderRedirectGuardInstalled) return;
    window.__preOrderRedirectGuardInstalled = true;

    function redirectIfBlocked(originalFn, context, url) {
      if (shouldBlockCheckoutRedirect(url)) {
        sessionStorage.setItem('preOrderPostLoginCheck', '1');
        return originalFn.call(context, cartReturnUrl());
      }
      return originalFn.call(context, url);
    }

    ['assign', 'replace'].forEach(function (method) {
      var original = window.Location.prototype[method];
      if (typeof original !== 'function') return;
      window.Location.prototype[method] = function (url) {
        return redirectIfBlocked(original, this, url);
      };
    });

    try {
      var hrefDescriptor = Object.getOwnPropertyDescriptor(window.Location.prototype, 'href');
      if (hrefDescriptor && hrefDescriptor.set && hrefDescriptor.get) {
        Object.defineProperty(window.Location.prototype, 'href', {
          configurable: true,
          enumerable: hrefDescriptor.enumerable,
          get: hrefDescriptor.get,
          set: function (url) {
            if (shouldBlockCheckoutRedirect(url)) {
              sessionStorage.setItem('preOrderPostLoginCheck', '1');
              return hrefDescriptor.set.call(this, cartReturnUrl());
            }
            return hrefDescriptor.set.call(this, url);
          }
        });
      }
    } catch (e) { /* ignore */ }
  }

  function armPreOrderLoginRedirect() {
    if (!shouldOverrideCheckoutLogin()) return false;
    if (!shouldForceCartReturn() && !syncCartHasPreOrderItems()) return false;
    sessionStorage.setItem('preOrderForceCartReturn', '1');
    sessionStorage.setItem('preOrderCartHasPreOrder', '1');
    window.preOrderBlockCheckoutRedirect(120000);
    rewriteOtpReturnToCart();
    startOtpReturnUrlWatcher();
    return true;
  }

  window.preOrderOnLoginSuccess = function () {
    var armed = armPreOrderLoginRedirect();
    if (!armed) return;

    if (window.simplyOtp && window.simplyOtp.settings && window.simplyOtp.settings.onlyOTPNoLogin) {
      redirectToCartAfterLogin();
    }
  };

  function initOtpInterceptors() {
    document.addEventListener('submit', function (e) {
      if (!e.target || e.target.id !== 'sotp-form') return;
      if (!shouldOverrideCheckoutLogin()) return;
      if (!shouldForceCartReturn()) return;
      window.preOrderBlockCheckoutRedirect(120000);
      rewriteOtpReturnToCart();
    }, true);

    document.body.addEventListener('sotp.login', function () {
      if (!shouldOverrideCheckoutLogin()) return;
      armPreOrderLoginRedirect();
    });

    document.body.addEventListener('sotp.register', function () {
      if (syncCartHasPreOrderItems() || sessionStorage.getItem('preOrderCartHasPreOrder') === '1') {
        armPreOrderLoginRedirect();
      }
    });
  }

  function initPreOrderCartFlag() {
    if (domHasPreOrderCartLines()) {
      sessionStorage.setItem('preOrderCartHasPreOrder', '1');
    }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.items.some(isPreOrderLineItem)) {
          sessionStorage.setItem('preOrderCartHasPreOrder', '1');
        } else {
          sessionStorage.removeItem('preOrderCartHasPreOrder');
        }
      })
      .catch(function () { /* ignore */ });
  }

  function stripLoginCheckoutUrlParam() {
    var params = new URLSearchParams(window.location.search);
    if (!params.has('checkout_url')) return false;

    params.delete('checkout_url');
    if (!params.has('return_url')) {
      params.set('return_url', '/cart?post_login=1');
    }

    var query = params.toString();
    var nextUrl = window.location.pathname + (query ? '?' + query : '');
    history.replaceState(null, '', nextUrl);
    return true;
  }

  function initLoginPageCheckoutUrlFix() {
    var params = new URLSearchParams(window.location.search);
    var hasCheckoutUrlParam = params.has('checkout_url');
    var onLoginPage = /\/account\/login/i.test(window.location.pathname);

    if (!hasCheckoutUrlParam && !onLoginPage) return;

    function applyLoginRedirectFix() {
      sessionStorage.setItem('preOrderForceCartReturn', '1');
      sessionStorage.setItem('preOrderCartHasPreOrder', '1');
      window.preOrderBlockCheckoutRedirect(120000);
      if (hasCheckoutUrlParam) stripLoginCheckoutUrlParam();
      rewriteOtpReturnToCart();
      startOtpReturnUrlWatcher();
    }

    function clearStalePreOrderFlagsForCheckout() {
      sessionStorage.removeItem('preOrderCartHasPreOrder');
      sessionStorage.removeItem('preOrderForceCartReturn');
      if (window.allowCheckoutAfterLogin) window.allowCheckoutAfterLogin();
    }

    if (hasCheckoutUrlParam && hasCheckoutLoginIntent()) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.items.some(isPreOrderLineItem)) {
            applyLoginRedirectFix();
          } else {
            clearStalePreOrderFlagsForCheckout();
          }
        })
        .catch(function () {
          clearStalePreOrderFlagsForCheckout();
        });
      return;
    }

    if (sessionStorage.getItem('preOrderCartHasPreOrder') === '1' ||
        sessionStorage.getItem('preOrderForceCartReturn') === '1') {
      applyLoginRedirectFix();
      return;
    }

    if (!hasCheckoutUrlParam) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.some(isPreOrderLineItem)) return;
        applyLoginRedirectFix();
      })
      .catch(function () { /* ignore */ });
  }

  function refreshCustomerPreOrderData() {
    return fetch('/?sections=pre-order-customer-data')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections && sections['pre-order-customer-data'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var script = doc.querySelector('script');
        if (!script || !script.textContent) return;
        try {
          new Function(script.textContent)();
        } catch (e) { /* ignore */ }
      })
      .catch(function () { /* ignore */ });
  }

  function proceedToCheckout(el) {
    window.__preOrderAllowCheckout = true;
    if (!el) return;
    if (el.tagName === 'A' && el.href) {
      window.location.href = el.href;
      return;
    }
    if (el.form) {
      if (typeof el.form.requestSubmit === 'function') {
        el.form.requestSubmit(el.name === 'checkout' ? el : undefined);
      } else {
        el.form.submit();
      }
      return;
    }
    if (typeof el.click === 'function') el.click();
  }

  function initGlobalCheckoutGuard() {
    document.addEventListener('click', function (e) {
      if (window.__preOrderAllowCheckout) {
        window.__preOrderAllowCheckout = false;
        return;
      }

      var checkoutEl = e.target.closest(
        '.btn-checkout, input[name="checkout"], button[name="checkout"], a.btn-checkout[href*="/checkout"], a[href*="/checkout"]'
      );
      if (!checkoutEl) return;

      if (document.body.classList.contains('pre-order-cart-blocked')) return;

      var isLoggedIn = document.body.classList.contains('customer-logged-in');

      if (!isLoggedIn) {
        if (syncCartHasPreOrderItems()) {
          markPreOrderCheckoutIntent();
        }
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      getCartPreOrderConflicts().then(function (conflicts) {
        if (conflicts.length) {
          window.location.href = '/cart?pre_order_blocked=1';
          return;
        }
        proceedToCheckout(checkoutEl);
      });
    }, true);

    document.addEventListener('submit', function (e) {
      if (window.__preOrderAllowCheckout) {
        window.__preOrderAllowCheckout = false;
        return;
      }

      if (document.body.classList.contains('pre-order-cart-blocked')) return;
      var form = e.target;
      if (!form || !form.matches('.cart-form, .wrapper-cart-template')) return;
      var submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;

      if (!document.body.classList.contains('customer-logged-in')) {
        if (syncCartHasPreOrderItems()) markPreOrderCheckoutIntent();
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      getCartPreOrderConflicts().then(function (conflicts) {
        if (conflicts.length) {
          window.location.href = '/cart?pre_order_blocked=1';
          return;
        }
        proceedToCheckout(submitter);
      });
    }, true);
  }

  function initPostLoginCartCheck() {
    var shouldCheck = sessionStorage.getItem('preOrderPostLoginCheck') === '1'
      || /[?&]post_login=1/.test(window.location.search);

    if (!shouldCheck) return;

    sessionStorage.removeItem('preOrderPostLoginCheck');
    window.preOrderBlockCheckoutRedirect();

    refreshCustomerPreOrderData().then(function () {
      return getCartPreOrderConflicts();
    }).then(function (conflicts) {
      if (conflicts.length) {
        setCartCheckoutBlocked(true, conflicts);
      } else {
        initCartPageGuard();
      }
    });
  }

  function initProductPageGuard() {
    var productRoot = document.querySelector('[data-product-id].is-pre-order, .sb-product-template--pre-order, .product.is-pre-order');
    if (!productRoot) return;
    var productId = productRoot.getAttribute('data-product-id');
    if (!productId) return;
    window.checkPreOrderAllowed(productId).then(function (result) {
      if (!result.allowed) {
        var form = document.querySelector(preOrderForms());
        if (form) showLimitMessage(form, result.reason);
      }
    });
  }

  function itemErrorMessage(title) {
    return 'You have already pre-ordered ' + title + '. Please remove this item from your cart to continue. Each customer can only pre-order a product once.';
  }

  function setCartCheckoutBlocked(blocked, conflicts) {
    document.body.classList.toggle('pre-order-cart-blocked', !!blocked);

    document.querySelectorAll('[data-pre-order-cart-item-msg]').forEach(function (el) {
      el.classList.remove('is-visible');
      el.style.display = 'none';
    });

    if (conflicts && conflicts.length) {
      conflicts.forEach(function (c) {
        var el = document.querySelector('[data-pre-order-cart-item-msg][data-product-id="' + c.productId + '"]');
        if (el) {
          el.textContent = itemErrorMessage(c.title);
          el.classList.add('is-visible');
          el.style.display = 'block';
        }
        var line = document.querySelector('li[data-product_id="' + c.productId + '"]');
        if (line) line.setAttribute('data-pre-order-line-blocked', 'true');
      });
    }

    document.querySelectorAll(
      '.btn-checkout, input[name="checkout"], button[name="checkout"], a.btn-checkout[href*="/checkout"]'
    ).forEach(function (el) {
      if (blocked) {
        el.disabled = true;
        el.setAttribute('aria-disabled', 'true');
        el.classList.add('pre-order-checkout-disabled');
      } else {
        el.disabled = false;
        el.removeAttribute('aria-disabled');
        el.classList.remove('pre-order-checkout-disabled');
      }
    });
  }

  function getCartPreOrderConflicts() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var conflicts = [];
        cart.items.forEach(function (item) {
          if (!isPreOrderLineItem(item)) return;
          if (customerHasPreOrderProduct(item.product_id)) {
            conflicts.push({
              productId: item.product_id,
              title: item.product_title,
              key: item.key
            });
          }
        });
        return conflicts;
      })
      .catch(function () { return []; });
  }

  function initCartPageGuard() {
    var cartForm = document.querySelector('.cart-form.wrapper-cart-template, .wrapper-cart-template');
    if (!cartForm) return;

    function runCheck() {
      if (window.preOrderCartBlocked) {
        var domConflicts = [];
        document.querySelectorAll('[data-pre-order-line-blocked="true"]').forEach(function (line) {
          domConflicts.push({
            productId: line.getAttribute('data-product_id'),
            title: line.querySelector('.product-name') ? line.querySelector('.product-name').textContent.trim() : 'this product'
          });
        });
        setCartCheckoutBlocked(true, domConflicts);
        return;
      }

      getCartPreOrderConflicts().then(function (conflicts) {
        setCartCheckoutBlocked(conflicts.length > 0, conflicts);
      });
    }

    runCheck();
  }

  document.addEventListener('click', function (e) {
    if (!document.body.classList.contains('pre-order-cart-blocked')) return;
    var checkoutEl = e.target.closest(
      '.btn-checkout, input[name="checkout"], button[name="checkout"], a[href*="/checkout"]'
    );
    if (!checkoutEl) return;
    e.preventDefault();
    e.stopPropagation();
    var alertEl = document.getElementById('pre-order-cart-alert');
    if (alertEl) alertEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var itemError = document.querySelector('[data-pre-order-cart-item-msg].is-visible');
    if (itemError) itemError.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  document.addEventListener('submit', function (e) {
    if (!document.body.classList.contains('pre-order-cart-blocked')) return;
    var form = e.target;
    if (!form || !form.matches('.cart-form, .wrapper-cart-template')) return;
    var submitter = e.submitter;
    if (submitter && (submitter.name === 'checkout' || submitter.classList.contains('btn-checkout'))) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  document.addEventListener('change', function (ev) {
    if (ev.target.matches('.pre-order-checkbox-input, [name="properties[Pre order]"]')) {
      var formId = ev.target.getAttribute('form');
      var form = formId ? document.getElementById(formId) : ev.target.closest('form');
      if (ev.target.checked) {
        hideCheckboxError(form);
      }
    }
  });

  document.addEventListener('click', function (ev) {
    var swatch = ev.target.closest('[data-sticky-add-to-cart] .pr-swatch');
    if (!swatch || swatch.classList.contains('sold-out')) return;
    var sticky = swatch.closest('[data-sticky-add-to-cart]');
    var productId = sticky && sticky.getAttribute('data-product-id');
    var variantId = swatch.getAttribute('data-value');
    if (productId && variantId) {
      window.updatePreOrderUI(productId, variantId);
    }
  });

  installCheckoutRedirectGuard();

  if (new URLSearchParams(window.location.search).has('checkout_url')) {
    if (hasCheckoutLoginIntent() && !syncCartHasPreOrderItems()) {
      sessionStorage.removeItem('preOrderCartHasPreOrder');
      sessionStorage.removeItem('preOrderForceCartReturn');
      if (window.allowCheckoutAfterLogin) window.allowCheckoutAfterLogin();
    } else if (sessionStorage.getItem('preOrderCartHasPreOrder') === '1' ||
        sessionStorage.getItem('preOrderForceCartReturn') === '1') {
      stripLoginCheckoutUrlParam();
      window.preOrderBlockCheckoutRedirect(120000);
      rewriteOtpReturnToCart();
    }
  }

  initLoginPageCheckoutUrlFix();
})();
